(function($, angular, window) {
    'use strict';
    window.THF.Angular.LiveQuoteTool.filter("renderIcon", function() {
        return function(htmlCode) {
            if (htmlCode == 'Y') {
                htmlCode = '<svg class="icon blue"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="'+THF.SiteSettings.svgSprite+'#ui-legend-covered"></use></svg>';
            }
            else if (htmlCode == 'N') {
                htmlCode = '<svg class="icon blue"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="'+THF.SiteSettings.svgSprite+'#ui-legend-not-covered"></use></svg>';
            }
            else if (htmlCode == 'NA') {
                htmlCode = '<svg class="icon grey"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="'+THF.SiteSettings.svgSprite+'#ui-legend-not-applicable"></use></svg>';
            }
            else if (htmlCode == 'P') {
                htmlCode = '<svg class="icon teal"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="'+THF.SiteSettings.svgSprite+'#ui-legend-partially-covered"></use></svg>';
            }
            else if (htmlCode == 'OF') {
                htmlCode = '<svg class="icon teal"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="'+THF.SiteSettings.svgSprite+'#ui-legend-other-features"></use></svg>';
            }
            else if (htmlCode == 'CS') {
                htmlCode = '<svg class="icon teal"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="'+THF.SiteSettings.svgSprite+'#ui-legend-covered-by-state-gov"></use></svg>';
            }
            else if (htmlCode == 'R') {
                htmlCode = '<svg class="icon teal"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="'+THF.SiteSettings.svgSprite+'#ui-legend-restricted"></use></svg>';
            }
            return htmlCode;
        }
    });
})(jQuery, angular, window);
